import Vue from 'vue'

import VInput from '@/components/control/v-input'
import VSelect from '@/components/control/v-select'
import VInputNumber from '@/components/control/v-input-number'
import VDatetimePicker from '@/components/control/v-datetime-picker'
import VDatePicker from '@/components/control/v-date-picker'
import VAutocomplete from '@/components/control/v-autocomplete'

Vue.component('v-input', VInput)
Vue.component('v-select', VSelect)
Vue.component('v-input-number', VInputNumber)
Vue.component('v-datetime-picker', VDatetimePicker)
Vue.component('v-date-picker', VDatePicker)
Vue.component('v-autocomplete', VAutocomplete)